module.exports = __webpack_public_path__ + "img/floor_OG2.db1aa46b.svg";